/**
 * @file companyData.js
 * @description 회사소개, 조직도, 위치, 연혁 페이지에 필요한 데이터 상수를 정의합니다.
 * @used-in pages/company/CompanyAboutPage.jsx, pages/company/CompanyHistoryPage.jsx, components/company/OrganizationChart.jsx
 * @migrated-from src/App.js
 */

export const companyValues = [
  {
    title: 'Mission',
    heading: '현장 운영을 더 정확하게',
    text: '제약·화장품 산업의 제조 현장을 더 정확하고 더 연결된 방식으로 운영할 수 있도록 돕습니다.',
  },
  {
    title: 'Vision',
    heading: '스마트 제조의 실행 파트너',
    text: '시스템 구축에 그치지 않고 운영과 개선까지 이어지는 스마트 제조 파트너가 되는 것이 목표입니다.',
  },
  {
    title: 'Core Value',
    heading: '현장 중심의 구현 역량',
    text: '업무 이해, 규정 대응, 안정적인 구축, 지속 가능한 지원을 핵심 가치로 삼고 있습니다.',
  },
];

export const organizationChart = {
  root: { name: '대표이사', subtitle: 'CEO' },
  support: { name: '경영지원팀', subtitle: 'Management Support' },
  divisions: [
    { name: 'SI부문', subtitle: 'System Integration', accent: '#153DC2', children: ['SI사업1팀', 'SI사업2팀', 'LG에너지솔루션', '자동화팀'] },
    { name: 'SM부문', subtitle: 'System Maintenance', accent: '#059669', children: ['운영팀'] },
    { name: 'AX추진팀', subtitle: 'AI Transformation', accent: '#7c3aed', children: [] },
    { name: '영업/기획/총괄', subtitle: 'Sales · Strategy', accent: '#d97706', children: [] },
  ],
};

export const officeLocations = [
  {
    id: 'hq',
    name: '본사',
    tag: 'HQ',
    lat: 36.63849211611629,
    lng: 127.44472279747954,
    address: '충북 청주시 흥덕구 봉명로 31',
    addressDetail: '티원타워 1216호',
    tel: '043-XXX-XXXX',
    directions: [
      { mode: '지하철', text: '청주역에서 차량 12분' },
      { mode: '버스', text: '봉명사거리 정류장 도보 3분' },
      { mode: '주차', text: '건물 지하 주차장 이용 가능' },
    ],
  },
  {
    id: 'anyang',
    name: '안양지사',
    tag: 'Branch',
    lat: 37.40109507961623,
    lng: 126.96908809690414,
    address: '경기 안양시 동안구 학의로 282',
    addressDetail: '금강펜테리움 IT타워 A관 607호',
    tel: '031-XXX-XXXX',
    directions: [
      { mode: '지하철', text: '인덕원역(4호선) 도보 8분' },
      { mode: '버스', text: '인덕원역 정류장 도보 5분' },
      { mode: '주차', text: '건물 주차장 이용 가능' },
    ],
  },
];

export const timeline = [
  { year: '2026.05', text: '남부센터 개소', highlight: true },
  { year: '2022.05', text: '청주티원타워 입주' },
  { year: '2021.05', text: '이노비즈(INNO-BIZ), 메인비즈(MAIN-BIZ) 획득', highlight: true },
  { year: '2015.05', text: 'ISO 9001 인증', highlight: true },
  { year: '2014.05', text: '오송생명과학단지 충북산학융합본부 입주' },
  { year: '2013.05', text: '안양사무소 개소' },
  { year: '2012.11', text: '기술보증기금 기술사업화 업체 선정' },
  { year: '2012.11', text: '칭량관리시스템, cGMP, EU-GMP 레퍼런스 사이트 구축', highlight: true},
  { year: '2012.10', text: '신풍제약(주) WMS 구축' },
  { year: '2011.12', text: '산업단지 클라우드 컴퓨팅 구축' },
  { year: '2011.09', text: '바이오서포트와 QRM 개발' },
  { year: '2010.11', text: '제약/화장품 MES GEMSv1.2 GOOD S/W인증' },
  { year: '2010.03', text: '기업부설연구소 인정' },
  { year: '2009.05', text: '포스텍 연구소와 공동으로 압타머 DB개발' },
  { year: '2008.08', text: '지역혁신인력양성사업 업체 선정' },
  { year: '2007.07', text: '품질경영시스템 인증(ISO 9001)' },
  { year: '2007.01', text: '벤처기업 인증(제061934235-1-0007호)' },
  { year: '2005.09', text: 'TBI(신기술보육사업) 업체로 선정' },
  { year: '2005.02', text: '법인전화 (주)새힘정보기술', highlight: true },
  { year: '2004.06', text: '칭량관리시스템 개발' },
  { year: '2004.03', text: '새힘정보기술 설립', highlight: true },
];
